import React, { useCallback } from "react";
import { Typography, makeStyles, createStyles } from "@material-ui/core";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    badge: {
      fontSize: 15,
      height: theme.spacing(2),
    },
  })
);

export default function Badge(props) {
  const { amount } = props;
  const classes = useStyles();

  const getBadge = useCallback((amount) => {
    const BADGE_MARK = "●";
    const MAX_AMOUNT = 99;
    const MAX_BADGE = `${BADGE_MARK}×${MAX_AMOUNT}+`;

    // amountが1～3の場合はその数に応じた●を表示
    if (1 <= amount && amount <= 3) {
      let badge = "";
      for (let i = 0; i < amount; i++) {
        badge += BADGE_MARK;
      }
      return badge;
    }
    // amountが最大値以上の場合はMAX_BADGEを表示
    else if (MAX_AMOUNT <= amount) {
      return MAX_BADGE;
    }
    // amountが4以上の場合は●×nと表示
    else if (4 <= amount) {
      return `${BADGE_MARK}×${amount}`;
    }
    // それ以外は空文字を表示
    else {
      return "";
    }
  }, []);

  return (
    <Typography color="primary" className={classes.badge}>
      {getBadge(amount)}
    </Typography>
  );
}
